<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    text: {
      type: [String, Number, Boolean],
      default: '',
    },
  },
}
</script>

<template>
  <VLayout row wrap align-center>
    <VFlex xs4>
      <VSubheader style="height: 25px;">{{ label }}</VSubheader>
    </VFlex>

    <VFlex xs8>
      <p class="mb-0">{{ text }}</p>
    </VFlex>
  </VLayout>
</template>
